<template>
  <div class="search-wrapper">
    <search-comp
      @onSearch="$emit('search', searchParams)"
      @onReset="
        searchParams = { ...defaultSearchParams }
        $emit('search', defaultSearchParams)
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div
                class="das-form-input"
                title="Tìm kiếm theo mã hồ sơ, họ, tên khách hàng"
              >
                <div class="label">
                  {{ $t('config.profile.searchBox.travellerInfo') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.name"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.nationality') }}
                </div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    :search-fields="['code', 'desc']"
                    index-field="id"
                    :selected-index-field-value="searchParams.nationId"
                    :columns="nationalityCols"
                    :rows="nationalityRows"
                    :value="searchParams.nationId"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectNation"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.desc || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.address') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.address"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.idCard') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.idCardOrVisa"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.email') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.email"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.phoneNumber') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.phoneNumber"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
  </div>
</template>

<script>
import { getAllNationality } from '../../commonApiCall'
export default {
  data: function () {
    return {
      searchShow: true,

      searchParams: {
        idCardOrVisa: null,
        email: null,
        address: null,
        phoneNumber: null,
        nationId: null, // id - number
        name: null
      },
      defaultSearchParams: {
        idCardOrVisa: null,
        email: null,
        address: null,
        phoneNumber: null,
        nationId: null, // id - number
        name: null
      },

      // nationality

      nationalityRows: []
    }
  },

  computed: {
    nationalityCols() {
      return [
        {
          headerName: this.$t('config.profile.select.nationalityCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.nationalityName'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ]
    }
  },

  async mounted() {
    this.nationalityRows = await getAllNationality()
  },

  methods: {
    onSelectNation(data) {
      this.searchParams.nationId = data?.id || null
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
}
</style>
